export const _staticGestures = state => state.gestures.staticGestures
